import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { rewardAPIWithErrorHandling } from "../../../api/reward/rewardApi";
import { resolveImageUrl } from "../../../utils/image";
import "../../../assets/css/reward.css";
import { semantic } from "../../../theme/tokens";

// ─── Inline styles / design tokens ───────────────────────────────────────────
// const css = `
//   @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=DM+Sans:wght@300;400;500&display=swap');

//   *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

//   :root {
//     --cream: #faf7f2;
//     --warm-white: #fffef9;
//     --ink: #1a1612;
//     --ink-light: #4a4540;
//     --accent: #c8853a;
//     --accent-light: #f0d9be;
//     --accent-pale: #fdf3e7;
//     --border: #e8e0d5;
//     --success: #4a8c6f;
//     --error: #c84a4a;
//     --shadow: 0 2px 24px rgba(26,22,18,0.08);
//     --shadow-hover: 0 8px 40px rgba(26,22,18,0.14);
//     --radius: 12px;
//   }

//   body { background: var(--cream); font-family: 'DM Sans', sans-serif; color: var(--ink); }

//   .page-wrap {
//     min-height: 100vh;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     padding: 0 0 80px;
//     position: relative;
//     overflow: hidden;
//   }

//   /* Background decoration */
//   .page-wrap::before {
//     content: '';
//     position: fixed;
//     top: -120px; right: -120px;
//     width: 480px; height: 480px;
//     border-radius: 50%;
//     background: radial-gradient(circle, #f0d9be55 0%, transparent 70%);
//     pointer-events: none;
//   }
//   .page-wrap::after {
//     content: '';
//     position: fixed;
//     bottom: -80px; left: -80px;
//     width: 320px; height: 320px;
//     border-radius: 50%;
//     background: radial-gradient(circle, #c8853a22 0%, transparent 70%);
//     pointer-events: none;
//   }

//   /* Hero / Banner */
//   .hero {
//     width: 100%;
//     min-height: 260px;
//     position: relative;
//     display: flex;
//     align-items: flex-end;
//     overflow: hidden;
//     background: linear-gradient(135deg, #2b1f14 0%, #4a3520 60%, #c8853a 100%);
//   }
//   .hero-bg {
//     position: absolute; inset: 0;
//     object-fit: cover; width: 100%; height: 100%;
//     opacity: 0.35;
//     filter: saturate(0.6);
//   }
//   .hero-overlay {
//     position: absolute; inset: 0;
//     background: linear-gradient(to top, rgba(26,22,18,0.85) 0%, rgba(26,22,18,0.2) 100%);
//   }
//   .hero-content {
//     position: relative; z-index: 1;
//     width: 100%; max-width: 680px;
//     margin: 0 auto;
//     padding: 40px 24px 36px;
//     display: flex;
//     flex-direction: column;
//     gap: 12px;
//   }
//   .hero-logo {
//     width: 56px; height: 56px;
//     border-radius: 14px;
//     object-fit: cover;
//     border: 2px solid rgba(255,255,255,0.25);
//     box-shadow: 0 4px 16px rgba(0,0,0,0.3);
//   }
//   .hero-logo-placeholder {
//     width: 56px; height: 56px;
//     border-radius: 14px;
//     background: rgba(255,255,255,0.15);
//     border: 2px solid rgba(255,255,255,0.25);
//     display: flex; align-items: center; justify-content: center;
//     font-size: 24px;
//   }
//   .hero-title {
//     font-family: 'Playfair Display', serif;
//     font-size: clamp(22px, 5vw, 32px);
//     font-weight: 700;
//     color: #fff;
//     line-height: 1.25;
//     letter-spacing: -0.01em;
//   }
//   .hero-desc {
//     font-size: 14px;
//     color: rgba(255,255,255,0.75);
//     line-height: 1.6;
//     max-width: 480px;
//   }

//   /* Card container */
//   .form-card {
//     width: 100%;
//     max-width: 680px;
//     margin: -32px auto 0;
//     background: var(--warm-white);
//     border-radius: 20px;
//     box-shadow: var(--shadow);
//     overflow: hidden;
//     position: relative;
//     z-index: 2;
//     animation: slideUp 0.5s cubic-bezier(0.22,1,0.36,1) both;
//   }
//   @keyframes slideUp {
//     from { opacity: 0; transform: translateY(32px); }
//     to   { opacity: 1; transform: translateY(0); }
//   }

//   .form-inner { padding: 36px 32px 40px; }

//   /* Field groups */
//   .field-group {
//     margin-bottom: 24px;
//     animation: fadeIn 0.4s ease both;
//   }
//   @keyframes fadeIn {
//     from { opacity: 0; transform: translateY(10px); }
//     to   { opacity: 1; transform: translateY(0); }
//   }

//   .field-label {
//     display: flex;
//     align-items: center;
//     gap: 6px;
//     font-size: 13.5px;
//     font-weight: 500;
//     color: var(--ink-light);
//     margin-bottom: 8px;
//     letter-spacing: 0.01em;
//   }
//   .field-label .required {
//     color: var(--error);
//     font-size: 15px;
//     line-height: 1;
//   }
//   .field-note {
//     font-size: 11.5px;
//     color: #9a9088;
//     padding: 4px 0;
//     font-style: italic;
//   }

//   /* Input base */
//   .field-input, .field-textarea, .field-select {
//     width: 100%;
//     padding: 12px 16px;
//     border: 1.5px solid var(--border);
//     border-radius: var(--radius);
//     font-family: 'DM Sans', sans-serif;
//     font-size: 14.5px;
//     color: var(--ink);
//     background: var(--cream);
//     transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
//     outline: none;
//     appearance: none;
//   }
//   .field-input:focus, .field-textarea:focus, .field-select:focus {
//     border-color: var(--accent);
//     background: var(--warm-white);
//     box-shadow: 0 0 0 3px var(--accent-light);
//   }
//   .field-input.error, .field-textarea.error, .field-select.error {
//     border-color: var(--error);
//     box-shadow: 0 0 0 3px #f8d5d5;
//   }
//   .field-textarea { resize: vertical; min-height: 90px; }
//   .field-select {
//     background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' fill='none'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%234a4540' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E");
//     background-repeat: no-repeat;
//     background-position: right 14px center;
//     padding-right: 40px;
//     cursor: pointer;
//   }

//   /* Radio / Checkbox group */
//   .options-group {
//     display: flex;
//     flex-direction: column;
//     gap: 10px;
//   }
//   .option-item {
//     display: flex;
//     align-items: center;
//     gap: 12px;
//     padding: 11px 16px;
//     border: 1.5px solid var(--border);
//     border-radius: var(--radius);
//     cursor: pointer;
//     transition: border-color 0.18s, background 0.18s;
//     user-select: none;
//   }
//   .option-item:hover { border-color: var(--accent); background: var(--accent-pale); }
//   .option-item.selected { border-color: var(--accent); background: var(--accent-pale); }
//   .option-item input[type="radio"],
//   .option-item input[type="checkbox"] { display: none; }
//   .option-dot {
//     width: 18px; height: 18px;
//     border-radius: 50%;
//     border: 2px solid var(--border);
//     display: flex; align-items: center; justify-content: center;
//     flex-shrink: 0;
//     transition: border-color 0.18s, background 0.18s;
//   }
//   .option-item.selected .option-dot {
//     border-color: var(--accent);
//     background: var(--accent);
//   }
//   .option-dot-inner {
//     width: 6px; height: 6px;
//     border-radius: 50%;
//     background: #fff;
//     opacity: 0;
//     transition: opacity 0.15s;
//   }
//   .option-item.selected .option-dot-inner { opacity: 1; }

//   .option-box {
//     width: 18px; height: 18px;
//     border-radius: 5px;
//     border: 2px solid var(--border);
//     display: flex; align-items: center; justify-content: center;
//     flex-shrink: 0;
//     transition: border-color 0.18s, background 0.18s;
//   }
//   .option-item.selected .option-box {
//     border-color: var(--accent);
//     background: var(--accent);
//   }
//   .option-check {
//     opacity: 0;
//     transition: opacity 0.15s;
//   }
//   .option-item.selected .option-check { opacity: 1; }

//   .option-label { font-size: 14px; color: var(--ink); }

//   /* Error text */
//   .error-text {
//     font-size: 12px;
//     color: var(--error);
//     margin-top: 5px;
//     display: flex;
//     align-items: center;
//     gap: 4px;
//   }

//   /* Divider */
//   .divider {
//     border: none;
//     border-top: 1px solid var(--border);
//     margin: 28px 0;
//   }

//   /* Submit button */
//   .submit-btn {
//     width: 100%;
//     padding: 15px 24px;
//     background: var(--accent);
//     color: #fff;
//     border: none;
//     border-radius: var(--radius);
//     font-family: 'DM Sans', sans-serif;
//     font-size: 15.5px;
//     font-weight: 500;
//     letter-spacing: 0.02em;
//     cursor: pointer;
//     transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     gap: 8px;
//   }
//   .submit-btn:hover:not(:disabled) {
//     background: #b5712e;
//     box-shadow: 0 6px 20px rgba(200,133,58,0.35);
//     transform: translateY(-1px);
//   }
//   .submit-btn:active:not(:disabled) { transform: translateY(0); }
//   .submit-btn:disabled { background: #d4c4b0; cursor: not-allowed; }

//   /* Loading spinner */
//   .spinner {
//     width: 18px; height: 18px;
//     border: 2px solid rgba(255,255,255,0.4);
//     border-top-color: #fff;
//     border-radius: 50%;
//     animation: spin 0.7s linear infinite;
//   }
//   @keyframes spin { to { transform: rotate(360deg); } }

//   /* Success screen */
//   .success-wrap {
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;
//     padding: 60px 32px;
//     text-align: center;
//     gap: 16px;
//     animation: slideUp 0.5s cubic-bezier(0.22,1,0.36,1) both;
//   }
//   .success-icon {
//     width: 72px; height: 72px;
//     border-radius: 50%;
//     background: #e8f5ef;
//     display: flex; align-items: center; justify-content: center;
//     font-size: 32px;
//     margin-bottom: 4px;
//   }
//   .success-title {
//     font-family: 'Playfair Display', serif;
//     font-size: 24px;
//     font-weight: 600;
//     color: var(--ink);
//   }
//   .success-msg {
//     font-size: 14.5px;
//     color: var(--ink-light);
//     line-height: 1.6;
//     max-width: 360px;
//   }

//   /* Skeleton loader */
//   .skeleton-wrap { padding: 36px 32px 40px; }
//   .skel {
//     background: linear-gradient(90deg, #ede8e0 25%, #f5f1eb 50%, #ede8e0 75%);
//     background-size: 200% 100%;
//     animation: shimmer 1.4s infinite;
//     border-radius: 8px;
//   }
//   @keyframes shimmer { to { background-position: -200% 0; } }

//   /* Error page */
//   .error-page {
//     display: flex; flex-direction: column;
//     align-items: center; justify-content: center;
//     min-height: 60vh;
//     gap: 12px;
//     padding: 40px 24px;
//     text-align: center;
//   }
//   .error-page-icon { font-size: 48px; }
//   .error-page-title { font-family: 'Playfair Display', serif; font-size: 22px; color: var(--ink); }
//   .error-page-msg { font-size: 14px; color: var(--ink-light); }

//   @media (max-width: 600px) {
//     .form-inner { padding: 28px 20px 36px; }
//     .hero-content { padding: 32px 20px 28px; }
//   }
// `;

// ─── API helpers ───────────────────────────────────────────────────────────────
// const BASE_URL = import.meta.env?.VITE_API_URL || "";
async function fetchForm(slug) {
    const response = await rewardAPIWithErrorHandling.khaosatSlug(slug);
    const res = response.data;
    if (!res.success) throw new Error("Không tìm thấy phiếu");
    return res.data;
}


async function submitForm(id, payload) {
    const response = await rewardAPIWithErrorHandling.guiKhaoSat(id, payload);
    const res = response.data;
    if (!res.success) throw new Error(res.message || "Gửi thất bại");
    return res.data;
}

// ─── Field renderers ───────────────────────────────────────────────────────────
function FieldInput({ field, value, onChange, hasError }) {
    const { dataType, options = [] } = field;

    if (dataType === "select") {
        return (
            <select
                className={`field-select${hasError ? " error" : ""}`}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">-- Chọn --</option>
                {options.map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
        );
    }

    if (dataType === "radio") {
        return (
            <div className="options-group">
                {options.map((o) => (
                    <label key={o} className={`option-item${value === o ? " selected" : ""}`} onClick={() => onChange(o)}>
                        <input type="radio" readOnly checked={value === o} />
                        <span className="option-dot"><span className="option-dot-inner" /></span>
                        <span className="option-label">{o}</span>
                    </label>
                ))}
            </div>
        );
    }

    if (dataType === "checkbox") {
        const checked = Array.isArray(value) ? value : [];
        const toggle = (o) => {
            if (checked.includes(o)) onChange(checked.filter((x) => x !== o));
            else onChange([...checked, o]);
        };
        
        return (
            <div className="options-group">
                {options.map((o) => (
                    <div key={o} className={`option-item${checked.includes(o) ? " selected" : ""}`} onClick={() => toggle(o)}>
                        <input type="checkbox" readOnly checked={checked.includes(o)} />
                        <span className="option-box">
                            <svg className="option-check" width="10" height="8" viewBox="0 0 10 8" fill="none">
                                <path d="M1 4l2.5 2.5L9 1" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                        <span className="option-label">{o}</span>
                    </div>
                ))}
            </div>
        );
    }

    if (dataType === "date") {
        return (
            <input
                type="date"
                className={`field-input${hasError ? " error" : ""}`}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
            />
        );
    }

    if (dataType === "number") {
        return (
            <input
                type="number"
                className={`field-input${hasError ? " error" : ""}`}
                placeholder={field.note || "Nhập số"}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
            />
        );
    }

    if (dataType === "email") {
        return (
            <input
                type="email"
                className={`field-input${hasError ? " error" : ""}`}
                placeholder={field.note || "email@example.com"}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
            />
        );
    }

    if (dataType === "phone") {
        return (
            <input
                type="tel"
                className={`field-input${hasError ? " error" : ""}`}
                placeholder={field.note || "0xxxxxxxxx"}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
            />
        );
    }

    // text / fallback — multiline if note suggests it
    return (
        <input
            type="text"
            className={`field-input${hasError ? " error" : ""}`}
            placeholder={field.note || "Nhập câu trả lời"}
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
        />
    );
}

// ─── Skeleton ──────────────────────────────────────────────────────────────────
function Skeleton() {
    return (
        <div className="skeleton-wrap">
            {[200, 160, 180, 140].map((w, i) => (
                <div key={i} style={{ marginBottom: 28 }}>
                    <div className="skel" style={{ height: 13, width: w, marginBottom: 10 }} />
                    <div className="skel" style={{ height: 46, borderRadius: 12 }} />
                </div>
            ))}
            <div className="skel" style={{ height: 52, borderRadius: 12, marginTop: 8 }} />
        </div>
    );
}

// ─── Main Page ─────────────────────────────────────────────────────────────────
export default function SurveyPublicPage() {
    const { slug } = useParams();
    // const id = 1;

    const [formData, setFormData] = useState(null);   // raw API data
    const [fields, setFields] = useState([]);          // parsed form fields
    const [values, setValues] = useState({});          // { [field.name]: value }
    const [errors, setErrors] = useState({});

    const [loading, setLoading] = useState(true);
    const [loadError, setLoadError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [submitError, setSubmitError] = useState(null);

    const [confirmChecked, setConfirmChecked] = useState(false);
    const [confirmError, setConfirmError]     = useState(false);

    // ── Load form ──────────────────────────────────────────────────────────────
    useEffect(() => {
        if (!slug) return;
        (async () => {
            try {
                const data = await fetchForm(slug);
                setFormData(data);

                // Parse form fields (may be JSON string)
                const raw = typeof data.form === "string" ? JSON.parse(data.form) : (data.form || []);
                setFields(raw);
            } catch (e) {
                setLoadError(e.message);
            } finally {
                setLoading(false);
            }
        })();
    }, [slug]);

    // ── Auto redirect after submit ────────────────────────────────────────────
    useEffect(() => {
        if (submitted && formData?.direct_url) {
            const t = setTimeout(() => {
                const url = formData.direct_url;
                const finalUrl = url.startsWith("http") ? url : `https://${url}`;

                window.open(finalUrl, "_blank", "noopener,noreferrer");
            }, 3000);

            return () => clearTimeout(t);
        }
    }, [submitted, formData]);

    const handleChange = (name, val) => {
        setValues((prev) => ({ ...prev, [name]: val }));
        setErrors((prev) => ({ ...prev, [name]: null }));
    };

    // ── Validate ───────────────────────────────────────────────────────────────
    const validate = () => {
        const errs = {};
        fields.forEach((f) => {
            const val = values[f.name];
            const hasVal = val !== undefined && val !== null && String(val).trim() !== "";

            // 1. Kiểm tra trường bắt buộc
            if (f.required) {
                if (f.dataType === "checkbox") {
                    if (!val || val.length === 0) {
                        errs[f.name] = "Vui lòng chọn ít nhất một giá trị";
                        return;
                    }
                } else if (!hasVal) {
                    errs[f.name] = "Trường này là bắt buộc";
                    return;
                }
            }

            // 2. Xác thực định dạng bất kể bắt buộc hay tùy chọn (nếu có điền giá trị)
            if (hasVal) {
                if (f.dataType === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
                    errs[f.name] = "Email không hợp lệ";
                } else if (f.dataType === "phone") {
                    const cleanPhone = String(val).replace(/\D/g, ""); // Loại bỏ +, khoảng trắng, gạch ngang
                    if (!/^[0-9]{9,11}$/.test(cleanPhone)) {
                        errs[f.name] = "Số điện thoại không hợp lệ";
                    }
                }
            }
        });
        return errs;
    };

    // ── Submit ─────────────────────────────────────────────────────────────────
    const handleSubmit = async () => {
        const errs = validate();
        if (Object.keys(errs).length > 0) { setErrors(errs); return; }

        // Chặn nếu có confirm nhưng chưa tích
        if (formData?.confirm && !confirmChecked) {
            setConfirmError(true);
            return;
        }

        setSubmitting(true);
        setSubmitError(null);
        try {
            await submitForm(formData.id, { answers: values });
            setSubmitted(true);
        } catch (e) {
            setSubmitError(e.message || "Gửi thất bại, vui lòng thử lại");
        } finally {
            setSubmitting(false);
        }
    };

    // ── Render ─────────────────────────────────────────────────────────────────
    return (
        <>
            {/* <style>{css}</style> */}
            <div className="page-wrap">

                {/* Hero banner */}
                <div className="hero">
                    {formData?.image_bg && (
                        <img className="hero-bg" src={resolveImageUrl(formData.image_bg)} alt="" />
                    )}
                    <div className="hero-overlay" />
                    <div className="hero-content">
                        {formData?.logo
                            ? <img className="hero-logo" src={resolveImageUrl(formData.logo)} alt="logo" />
                            : <div className="hero-logo-placeholder">📋</div>
                        }
                        <h1 className="hero-title">
                            {formData?.title || (loading ? "Đang tải..." : "Phiếu khảo sát")}
                        </h1>
                        {formData?.description && (
                            <p className="hero-desc">{formData.description}</p>
                        )}
                    </div>
                </div>

                {/* Card */}
                <div className="form-card">

                    {loading && <Skeleton />}

                    {loadError && (
                        <div className="error-page">
                            <div className="error-page-icon">😕</div>
                            <div className="error-page-title">Không thể tải phiếu</div>
                            <div className="error-page-msg">{loadError}</div>
                        </div>
                    )}

                    {submitted && (
                        <div className="success-wrap">
                            <div className="success-icon">✅</div>
                            <div className="success-title">Cảm ơn bạn!</div>
                            <div className="success-msg">
                                {formData?.message || "Phiếu của bạn đã được ghi nhận thành công."}
                            </div>
                            {/* {formData?.direct_url && (
                                <div style={{ fontSize: 13, color: "#9a9088", marginTop: 4 }}>
                                    Bạn sẽ được chuyển trang sau 3 giây...
                                </div>
                            )} */}
                        </div>
                    )}

                    {!loading && !loadError && !submitted && (
                        <div className="form-inner">

                            {/* Dynamic fields */}
                            {fields.map((field, idx) => (
                                <div
                                    key={field.id || field.name}
                                    className="field-group"
                                    style={{ animationDelay: `${idx * 0.06}s` }}
                                >
                                    <label className="field-label">
                                        {field.question || field.name}
                                        {field.required && <span className="required">*</span>}
                                    </label>

                                    {field.note && (
                                        <div className="field-note">💡 {field.note}</div>
                                    )}

                                    <FieldInput
                                        field={field}
                                        value={values[field.name]}
                                        onChange={(val) => handleChange(field.name, val)}
                                        hasError={!!errors[field.name]}
                                    />

                                    {/* {field.note && !["select","radio","checkbox"].includes(field.dataType) && (
                                        <div className="field-note">💡 {field.note}</div>
                                    )} */}
                                    {errors[field.name] && (
                                        <div className="error-text">
                                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                <circle cx="6.5" cy="6.5" r="6" stroke="#c84a4a" strokeWidth="1.2"/>
                                                <path d="M6.5 3.5v3.5" stroke="#c84a4a" strokeWidth="1.3" strokeLinecap="round"/>
                                                <circle cx="6.5" cy="9.5" r="0.7" fill="#c84a4a"/>
                                            </svg>
                                            {errors[field.name]}
                                        </div>
                                    )}
                                </div>
                            ))}

                            {formData?.confirm && (
                                <div style={{
                                    background: "var(--accent-pale)",
                                    border: "1px solid var(--accent-light)",
                                    borderRadius: 10,
                                    padding: "14px 18px",
                                    marginBottom: 28,
                                }}>
                                    <label
                                        style={{ display: "flex", alignItems: "flex-start", gap: 12, cursor: "pointer" }}
                                        onClick={() => {
                                            const nextVal = !confirmChecked;
                                            setConfirmChecked(nextVal);
                                            if (nextVal) setConfirmError(false);
                                        }}
                                    >
                                        <span style={{
                                            width: 20, height: 20, borderRadius: 5, flexShrink: 0, marginTop: 1,
                                            border: `2px solid ${confirmChecked ? "var(--accent)" : "var(--border)"}`,
                                            background: confirmChecked ? "var(--accent)" : "transparent",
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            transition: "all 0.18s",
                                        }}>
                                            {confirmChecked && (
                                                <svg width="11" height="9" viewBox="0 0 11 9" fill="none">
                                                    <path d="M1 4.5l3 3L10 1" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            )}
                                        </span>
                                        <span style={{ fontSize: 13.5, color: "#7a5020", lineHeight: 1.6 }}>
                                            {formData.confirm}
                                        </span>
                                    </label>
                                    {confirmError && (
                                        <div className="error-text" style={{ marginTop: 8, marginLeft: 32 }}>
                                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                                <circle cx="6.5" cy="6.5" r="6" stroke="#c84a4a" strokeWidth="1.2"/>
                                                <path d="M6.5 3.5v3.5" stroke="#c84a4a" strokeWidth="1.3" strokeLinecap="round"/>
                                                <circle cx="6.5" cy="9.5" r="0.7" fill="#c84a4a"/>
                                            </svg>
                                            Vui lòng xác nhận trước khi gửi
                                        </div>
                                    )}
                                </div>
                            )}

                            {fields.length === 0 && (
                                <div style={{ textAlign: "center", color: "#9a9088", padding: "24px 0", fontSize: 14 }}>
                                    Phiếu này chưa có câu hỏi nào.
                                </div>
                            )}

                            <hr className="divider" />

                            {/* Error Banner — thay thế alert() */}
                            {submitError && (
                                <div style={{
                                    display: "flex", alignItems: "center", gap: 10,
                                    background: "linear-gradient(135deg, #fff5f5 0%, #fed7d7 100%)",
                                    border: "1px solid #feb2b2",
                                    borderRadius: 10,
                                    padding: "12px 16px",
                                    marginBottom: 16,
                                    animation: "fadeIn 0.35s ease",
                                }}>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ flexShrink: 0 }}>
                                        <circle cx="9" cy="9" r="8" stroke="#c84a4a" strokeWidth="1.4"/>
                                        <path d="M9 5v4.5" stroke="#c84a4a" strokeWidth="1.5" strokeLinecap="round"/>
                                        <circle cx="9" cy="13" r="0.8" fill="#c84a4a"/>
                                    </svg>
                                    <span style={{ fontSize: 13.5, color: "#9b2c2c", lineHeight: 1.5, flex: 1 }}>
                                        {submitError}
                                    </span>
                                    <button
                                        onClick={() => setSubmitError(null)}
                                        style={{
                                            background: "none", border: "none", cursor: "pointer",
                                            color: semantic.danger, fontSize: 16, padding: 2, lineHeight: 1,
                                        }}
                                        title="Đóng"
                                    >✕</button>
                                </div>
                            )}

                            <button
                                className="submit-btn"
                                onClick={handleSubmit}
                                disabled={submitting || fields.length === 0}
                            >
                                {submitting
                                    ? <><div className="spinner" /> Đang gửi...</>
                                    : <>
                                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                                            <path d="M2 8.5h13M9.5 3l6 5.5-6 5.5" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                        Gửi phiếu
                                    </>
                                }
                            </button>
                        </div>
                    )}
                </div>

                {/* Footer note */}
                {!loading && !loadError && (
                    <div style={{ marginTop: 24, fontSize: 12, color: "#b0a898", textAlign: "center" }}>
                        Thông tin của bạn được bảo mật và chỉ dùng cho mục đích khảo sát.
                    </div>
                )}
            </div>
        </>
    );
}